import { Module, VuexModule, Mutation } from 'vuex-module-decorators'
import { CreditMemoQuery } from '~/graphql/types'

@Module({
  name: 'credit-memo',
  stateFactory: true,
  namespaced: true,
})
export default class CreditMemo extends VuexModule {
  fetchStarted = false
  loading = true
  items: CreditMemoQuery['credit_memo'] = []

  @Mutation
  setFetchStarted(fetchStarted) {
    this.fetchStarted = fetchStarted
  }

  @Mutation
  setLoading(loading) {
    this.loading = loading
  }

  @Mutation
  setItems(items) {
    this.items = items
  }
}
